import React, { PureComponent } from 'react';
import { message, Modal, Upload, Button } from 'antd';
import * as XLSX from 'xlsx';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';
import './index.less';
const api = services.api;
interface UploadButtonState {
    showUploadModal: boolean;
    toggleUploadModal: any;
    type: string;
}

export class ShowProductsUploadButton extends PureComponent<UploadButtonState> {
    /**
     * 默认的上传处理,成功后触发外部回调
     * @param info
     */
    //  onChange(info) {
    //   if (info.file.status !== 'uploading') {
    //     console.log(info.file, info.fileList);
    //   }
    //   if (info.file.status === 'done') {
    //     message.success(`${info.file.name} file uploaded successfully`);
    //   } else if (info.file.status === 'error') {
    //     message.error(`${info.file.name} file upload failed.`);
    //   }
    // }
    /**
     * 上传前校验文件大小
     * @param file
     * @returns {boolean}
     */
    // beforeUpload(file: any){
    //   const maxSize  = 100 * 1024;
    //   if (maxSize && file.size > maxSize * 1024) {
    //     message.error('上传文件大小不能超过 ' + maxSize + 'KB');
    //       return false;
    //   }
    //   return !this.state.confirmLoading;
    // }
    state = {
        confirmLoading: false,
        modalTitle: '批量导入商品',
        apiRoot: ENV.API_ROOT,
        skuArr: [],
    };
    // modal关闭
    handleCancel = () => {
        this.props.toggleUploadModal();
    };
    // 导入excel后将excel中的sku读取出来，并输出为json形式
    onImportExcel = (file) => {
        // 获取上传的文件对象
        const { files } = file.target;
        // 通过FileReader对象读取文件
        const fileReader = new FileReader();
        fileReader.onload = (event) => {
            try {
                const { result } = event.target;
                // 以二进制流方式读取得到整份excel表格对象
                const workbook = XLSX.read(result, { type: 'binary' });
                // 存储获取到的数据
                let data = [];
                // 遍历每张工作表进行读取（这里默认只读取第一张表）
                for (const sheet in workbook.Sheets) {
                    // esline-disable-next-line
                    if (workbook.Sheets.hasOwnProperty(sheet)) {
                        // 利用 sheet_to_json 方法将 excel 转成 json 数据
                        data = data.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
                        break; // 如果只取第一张表，就取消注释这行
                    }
                }
                // 最终获取到并且格式化后的 json 数据,进行具体业务校验
                this.checkArr(data);
                // console.log('数据呢？',data);
            } catch (e) {
                // 这里可以抛出文件类型错误不正确的相关提示
                message.error('文件类型不正确！', 3);
            }
        };
        // 以二进制方式打开文件
        fileReader.readAsBinaryString(files[0]);
    };
    // 格式化后的 json 数据,具体业务校验
    checkArr = (data) => {
        const { type } = this.props;
        let arr = [];
        if (data.length) {
            if (type && type == 'presellOrder') {
                data.forEach((item) => {
                    if (item['SKN编码']) {
                        arr.push(item['SKN编码']);
                    }
                });
            } else if (type && type == 'liveProduct') {
                console.log(data);
                data.forEach((item, index) => {
                    let liveObject: any = {};
                    liveObject.sku_code = item['SKU编码'];
                    liveObject.name = item['商品名称'];
                    liveObject.price_type = item['价格类型(1：一口价 2：价格区间 3：显示折扣价)'];
                    liveObject.price_first = item['Price1(价格)'];
                    liveObject.price_second = item['Price2(价格,注:价格类型是2或3时此字段必填)'];
                    arr.push(liveObject);
                });
            } else {
                data.forEach((item) => {
                    if (item['SKU编码']) {
                        arr.push(item['SKU编码']);
                    }
                });
            }
        } else {
            message.error('导入的数据不能为空！', 3);
            return;
        }
        console.log('skuarr是啥', arr);
        if (arr.length == 0) {
            message.error('导入的表格数据格式有误！', 3);
            return;
        } else {
            message.success("文件解析成功！点击'确定'导入", 2);
            this.setState({
                skuArr: arr,
            });
        }
    };
    // modal确认时调用接口，将skus传给后台，后台返回对应sku所有信息
    handleOk = async () => {
        const { type } = this.props;
        const { skuArr } = this.state;
        this.setState({
            confirmLoading: true,
        });
        if (type && type == 'presellOrder') {
            let res = await this.getskuListBySkus(type, skuArr);
            this.setState({
                confirmLoading: false,
            });
            this.props.toggleUploadModal(res);
        } else if (type && type == 'liveProduct') {
            let res = await this.getskuListBySkus(type, skuArr);
            this.setState({
                confirmLoading: false,
            });
            this.props.toggleUploadModal(res);
        } else {
            let results = []; // 用于存放最新的对应商品信息得商品数组
            let n = 20; // 多少个为一组得步长
            // 将skuarr分为20个为一组，遍历请求接口，防止数据量多时造成接口超时报错
            for (let i = 0; i < Math.ceil(skuArr.length / n); i++) {
                // 用原来的skus换取最新的对应商品信息
                let first = await this.getskuListBySkus(
                    type,
                    skuArr.slice(i * n, i * n + n).join()
                );
                results = results.concat(first);
            }
            if (skuArr.length === results.length) {
                message.success('获取导入商品信息成功', 3);
            } else {
                let diffSku = '';
                skuArr.forEach((skuItem) => {
                    results.forEach((resItem) => {
                        if (resItem.sku !== skuItem) {
                            diffSku += skuItem + ',';
                        }
                    });
                });
                diffSku = diffSku.slice(0, -1);
                message.info(`未拼配到 ${diffSku} 商品信息`, 3);
            }
            this.setState({
                confirmLoading: false,
            });
            this.props.toggleUploadModal(results);
        }
    };
    getskuListBySkus = async (type, skus) => {
        if (type && type == 'presellOrder') {
            let res: any = await api.post(
                { sknCodes: skus },
                { apiPath: '/preOrder/importSkn', apiRoot: ENV.API_ROOT }
            );
            return res;
        } else if (type && type == 'liveProduct') {
            let res: any = await api.post(skus, {
                apiPath: '/live/products/batchAdd',
                apiRoot: ENV.API_ROOT,
            });
            return res;
        } else {
            let res: any = await api.get(
                { type: type, page: 1, per_page: 1000, skus: skus },
                { apiPath: '/products', apiRoot: ENV.API_ROOT }
            );
            return res.result;
        }
    };
    render() {
        const { showUploadModal, type } = this.props;
        const { confirmLoading, modalTitle, apiRoot } = this.state;
        return (
            <Modal
                destroyOnClose={true}
                maskClosable={false}
                centered
                title={modalTitle}
                visible={showUploadModal}
                onOk={this.handleOk}
                confirmLoading={confirmLoading}
                onCancel={this.handleCancel}
            >
                <Button type="primary" className="upload-wrap">
                    <input
                        className="file-uploader"
                        type="file"
                        accept=".xlsx"
                        onChange={this.onImportExcel}
                    />
                    <span className="upload-text">
                        批量导入
                        {type && type == 'presellOrder'
                            ? 'SKN'
                            : type == 'liveProduct'
                            ? '商品'
                            : 'SKU'}
                    </span>
                </Button>
                <p className="upload-tip">支持 .xlsx 格式的文件</p>
                {/* &nbsp;&nbsp;&nbsp;&nbsp; */}
                {/* <Button type="default">下载模板</Button> */}
            </Modal>
        );
    }
}
